import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { AppErrorBoundary } from './components/AppErrorBoundary.tsx';
import { initNativeShell } from './nativeShell.ts';
import './styles.css';

const container = document.querySelector('#root');
if (!container) throw new Error('#root bulunamadı');

createRoot(container).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);

// Native kabuk yalnızca Capacitor içinde etkinleşir; web'de no-op.
initNativeShell();

/*
 * PWA service worker — yalnız üretimde.
 *
 * Geliştirmede kayıt etmek, Vite'ın HMR akışını önbellek katmanıyla
 * karıştırır; bu yüzden `import.meta.env.PROD` şartı var.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
